'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import {
  Trophy,
  Home,
  Settings,
  LogOut,
  Menu,
} from 'lucide-react'
import { useState } from 'react'

const judgeNavItems = [
  {
    label: 'Dashboard',
    href: '/judge/dashboard',
    icon: Home,
  },
  {
    label: 'My Competitions',
    href: '/judge/competitions',
    icon: Trophy,
  },
  {
    label: 'Results',
    href: '/judge/results',
    icon: Trophy,
  },
  {
    label: 'Help',
    href: '/judge/help',
    icon: Settings,
  },
]

export function JudgeSidebar() {
  const pathname = usePathname()
  const [open, setOpen] = useState(true)

  return (
    <>
      {/* Sidebar */}
      <aside
        className={cn(
          'fixed left-0 top-0 z-40 flex h-full flex-col border-r border-border bg-card transition-all duration-300',
          open ? 'w-64' : 'w-20'
        )}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b border-border p-4">
          {open && <div className="text-lg font-bold text-primary">Cosmicon Events</div>}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setOpen(!open)}
            className="h-8 w-8 p-0"
          >
            <Menu className="h-4 w-4" />
          </Button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 space-y-2 p-4">
          {judgeNavItems.map((item) => {
            const Icon = item.icon
            const isActive = pathname === item.href || pathname.startsWith(item.href + '/')

            return (
              <Link key={item.href} href={item.href}>
                <Button
                  variant={isActive ? 'default' : 'ghost'}
                  className={cn(
                    'w-full justify-start',
                    !open && 'justify-center px-2'
                  )}
                  size="sm"
                >
                  <Icon className="h-4 w-4" />
                  {open && <span className="ml-2">{item.label}</span>}
                </Button>
              </Link>
            )
          })}
        </nav>

        {/* Logout */}
        <div className="border-t border-border p-4">
          <Link href="/">
            <Button
              variant="outline"
              className={cn(
                'w-full justify-start',
                !open && 'justify-center px-2'
              )}
              size="sm"
            >
              <LogOut className="h-4 w-4" />
              {open && <span className="ml-2">Logout</span>}
            </Button>
          </Link>
        </div>
      </aside>

      {/* Spacer for fixed sidebar */}
      <div className={cn('transition-all duration-300', open ? 'w-64' : 'w-20')} />
    </>
  )
}
